// extracted by mini-css-extract-plugin
export default {"root":"styles_root__vRbpX","wrapper":"styles_wrapper__BfAQl","headBlock":"styles_headBlock__zSq8X","aboveTitle":"styles_aboveTitle__qP9I1","title":"styles_title__kvliA"};